<template>
	<div>
		<div class="midlle">
			<div class="myProject" v-if="loading">
				<div class="title">
					<span class="tit">我已发布的根据内容定位</span>
					<p>您已发布{{releasedListLength}}个根据内容定位
					</p>
				</div>
				<div class="myProject-main" v-if='releasedListLength>0'>
					<div class="item" v-for="(item,index) in relesedList" :key="index">
						<div class="main">

							<div class="body">
								<div class="image" @click="goto(`/ktdwDetail/?id=${item.id}`)">
									<img :src='getImgSrc(item.image)' alt="">
								</div>

								<div style="width: 100%;display: flex;justify-content: center;">
									<p
										style="font-size: 18px;overflow: hidden;width: 150px;text-align: center;text-overflow: ellipsis;white-space: nowrap;overflow: hidden; ">
										{{item.title}}
									</p>
								</div>
								<div class="status">
									<span style="color:chocolate;font-size: large;" v-if="item.status == 0"> 待处理</span>
									<span style="color:seagreen;font-size: large;" v-if="item.status== 1"> 已处理</span>
								</div>
							</div>
						</div>
						<!-- <div class="bottom">
							<p v-if="item.status == 0">已过期，<span style="color: #0052D9;">去更新</span></p>
							<p v-else>有<span style="color: #0052D9;">{{item.new}}</span>条咨询</p>
						</div> -->
					</div>
				</div>
				<div class="body-mid-main" style="display: flex;justify-content: center;" v-else>
					<el-empty :image-size="200"></el-empty>
				</div>
				<!-- <div class="body-mid-footer" @click="loadingMoreRelesed"
					v-if="relesedList.current_page < relesedList.last_page">
					加载更多<img src='../../../assets/images/darrwo.png' alt="">
				</div> -->
			</div>
			
		</div>
		<div class="midlle">
			<div class="myProject" v-if="loading">
				<div class="title">
					<span class="tit">我已发布的邀请专家定位</span>
					<p>您已发布{{releasedListLength1}}个邀请专家定位
					</p>
				</div>
				<div class="myProject-main" v-if='releasedListLength>0'>
					<div class="item" v-for="(item,index) in relesedList1" :key="index">
						<div class="main">
							<div class="head">
								<!-- <div>浏览: <span>{{item.hits == null ? 0: item.hits}}</span></div>
								<div>收藏: <span>{{item.collect_num}}</span></div> -->
								<!-- <div>点赞: <span>{{item.like}}</span></div> -->
							</div>
							<div class="body">
								<div class="image" @click="goto(`/ktdwzjDetail/?id=${item.id}`)">
									<img :src='getImgSrc(item.image)' alt="">
								</div>
		
								<div style="width: 100%;display: flex;justify-content: center;">
									<p
										style="font-size: 18px;overflow: hidden;width: 150px;text-align: center;text-overflow: ellipsis;white-space: nowrap;overflow: hidden; ">
										{{item.title}}
									</p>
								</div>
								<div class="status">
									<span style="color:chocolate;font-size: large;" v-if="item.status == 0"> 待处理</span>
									<span style="color:seagreen;font-size: large;" v-if="item.status== 1"> 已处理</span>
								</div>
							</div>
						</div>
						<!-- <div class="bottom">
							<p v-if="item.status == 0">已过期，<span style="color: #0052D9;">去更新</span></p>
							<p v-else>有<span style="color: #0052D9;">{{item.new}}</span>条咨询</p>
						</div> -->
					</div>
				</div>
				<div class="body-mid-main" style="display: flex;justify-content: center;" v-else>
					<el-empty :image-size="200"></el-empty>
				</div>
				<!-- <div class="body-mid-footer" @click="loadingMoreRelesed"
					v-if="relesedList.current_page < relesedList.last_page">
					加载更多<img src='../../../assets/images/darrwo.png' alt="">
				</div> -->
			</div>
			
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				releasedListLength:0,
				releasedListLength1:0,
				centerDialogVisible: false,
				cities6: [{
					id: 1,
					name: '发布'
				}, {
					id: 2,
					name: '交互'
				}, {
					id: 3,
					name: '收藏'
				}, {
					id: 4,
					name: '点赞'
				}, {
					id: 5,
					name: '转发'
				}, ],
				checkedCities: 1,
				myProject: [],
				tableData3: [],
				serveData: {
					type: 3, //1项目需求2资源工具池3解决方案4产品服务
					order: 'id desc', //id asc
					cate: 1, //	1发布2交互3收藏4点赞5转发
					page: 1
				},
				relesedList: [],
				relesedList1: [],
				relesedPage: 1,
				loading: false
			}
		},
		created() {
			this.getmycontentPosition()
			this.getmyzjPosition()
		},
		computed: {
			checkLb() {
				return this.cities6.filter(item => this.checkedCities == item.id)
			}
		},
		methods: {
			async getmycontentPosition() {
				const relesed = await this.$api.mycontentPosition({
					
				})
				this.relesedList = relesed.data.data
				this.releasedListLength = relesed.data.data.length
				this.loading = true
				console.log('我的内容定位：',this.relesedList);
			},
			async getmyzjPosition() {
				const relesed = await this.$api.myzjPosition({
					
				})
				this.relesedList1 = relesed.data.data
				this.releasedListLength1 = relesed.data.data.length
				this.loading = true
				console.log('我的专家定位：',this.relesedList1);
			},
			goto(url) {
				this.$router.push(url)
			},
		}
	}
</script>
<style>
	/* 	.el-radio__label {
		color: black;
	}
	
	.radio {
		position: relative;
		display: inline-block;
		margin-right: 12px;
	}
	
	.radio input {
		width: 15px;
		height: 15px;
		appearance: none;
		-webkit-appearance: none;
		opacity: 0;
		outline: none;
	}
	
	.radio label {
		position: absolute;
		left: 0;
		top: 6px;
		width: 15px;
		height: 15px;
		border: 1px solid #bcbcbc;
	}
	
	.el-radio__inner {
		border-radius: 0;
	}
	
	.el-radio__inner::after {
		content: "";
		position: absolute;
		text-align: center;
		border-radius: 0;
		width: 14px;
		height: 14px;
		content: "✓";
		color: #fff;
		font-weight: bold;
		background-color: #0052D9;
	} */

	.el-checkbox__input.is-checked .el-checkbox__inner {
		background-color: #0052D9;
		border-color: #0052D9;
	}

	.el-checkbox__input.is-checked+.el-checkbox__label {
		color: #0052D9;
	}
</style>
<style lang="less" scoped>
	.midlle-body {
		padding-bottom: 10px;

		/deep/.link {
			color: #0052D9;
			cursor: pointer;
			display: flex;
			justify-content: space-around;
		}

		margin-top: 20px;
		padding-top: 20px;
		box-sizing: border-box;
		background: white;

		.body-title {
			color: #0052D9;
			display: flex;
			margin-bottom: 20px;
			font-weight: bold;
			font-size: 18px;

			.line {
				width: 4px;
				height: 22px;
				background: #0052D9;
			}
		}

		.loading {
			cursor: pointer;
			width: 116px;
			height: 40px;
			background: #F6F6F6;
			display: flex;
			align-items: center;
			margin: 10px;
			margin-bottom: 0;
			justify-content: center;
		}

	}

	.midlle {
		.myProject {
			.body-mid-footer {
				width: 96%;
				margin: 0 auto;
				display: flex;
				box-sizing: border-box;
				height: 50px;
				background: #F6F6F6;
				justify-content: center;
				font-size: 18px;
				cursor: pointer;
				align-items: center;

				&>img {
					margin-left: 20px;
					width: 16px;
					height: 16px;
				}
			}

			.myProject-main {
				display: flex;
				flex-wrap: wrap;

				.item {
					margin-bottom: 20px;
					margin-left: 10px;

					.bottom {
						margin-top: 15px;
						text-align: center;
						color: #888;
						width: 100%;
						height: 25px;
						background: #F6F6F6;
					}

					.main:hover {
						transform: scale(1.02);
						box-shadow: 0 0 10px #d0d0d0;
					}

					.main {
						transition: all .3s;
						position: relative;
						align-content: flex-start;
						width: 256px;
						height: 276px;
						border: 1px solid #8b8b8b;
						display: flex;
						flex-wrap: wrap;
						padding: 15px 20px;
						box-sizing: border-box;
						justify-content: center;

						.body {
							.status {
								position: absolute;
								bottom: 15px;

								p {
									color: #888;
									display: flex;
									align-items: center;
								}
							}

							margin-top: 20px;
							display: flex;
							justify-content: center;
							flex-wrap: wrap;

							.image {
								cursor: pointer;
								width: 100px;
								height: 100px;
								border-radius: 50%;
								overflow: hidden;
								margin-bottom: 25px;

								img {
									width: 100%;
									height: 100%;
								}
							}
						}

					}

					.head {
						height: 20px;

						span {
							color: #0052D9;
						}

						width: 100%;
						font-size: 14px;
						justify-content: space-around;
						display: flex;
					}
				}

				padding: 25px 15px;
			}

			.title {
				display: flex;
				height: 40px;
				background: #E5EDFB;
				align-items: center;

				p {
					font-size: 14px;
					color: black;
					margin-left: 10px;

					span {
						color: #0052D9;
					}
				}

				.tit {
					display: inline-block;
					padding: 0 20px;
					background: #0052D9;
					height: 40px;
					line-height: 40px;
					color: white;
					font-size: 18px;
					border-radius: 0px 20px 20px 0px;
					font-weight: bold;
				}
			}

			width: 840px;
			padding: 20px 0;
			background: #FFFFFF;
		}

		width: 880px;
		padding: 0 20px;
		box-sizing: border-box;
	}
</style>